import { render, staticRenderFns } from "./superviseTemplateCompany.vue?vue&type=template&id=30d2f228&scoped=true&"
import script from "./superviseTemplateCompany.vue?vue&type=script&lang=js&"
export * from "./superviseTemplateCompany.vue?vue&type=script&lang=js&"
import style0 from "./superviseTemplateCompany.vue?vue&type=style&index=0&id=30d2f228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d2f228",
  null
  
)

export default component.exports